<div class="surface-card p-5 m-3 shadow-1 border-round">
  <div class="grid">
    <div class="col-8 font-medium text-2xl text-700 mb-3">
      <i class="pi pi-user"></i>
      Cliente
    </div>
    <div class="col-1">
      <button
        pButton
        pRipple
        icon="pi pi-user-plus"
        class="p-button-rounded p-button-warning"
        (click)="openClientCreate = true"
        pTooltip="Crear Cliente"
        tooltipPosition="left"
      ></button>
    </div>
    <div class="col-1">
      <button
        pButton
        pRipple
        icon="pi pi-check-square"
        class="p-button-rounded p-button-info"
        (click)="select.client.openDialog = true"
        pTooltip="Seleccionar Cliente"
        tooltipPosition="left"
      ></button>
    </div>
    <div class="col-1">
      <button
        pButton
        pRipple
        icon="pi pi-user"
        class="p-button-rounded p-button-success"
        (click)="setClientDefault()"
        pTooltip="Establecer Cliente Default"
        tooltipPosition="left"
      ></button>
    </div>
  </div>
  <div class="text-500 mb-5">
    Revisar la información del cliente, antes de pasar al siguiente paso.
  </div>
  <ul class="list-none p-0 m-0">
    <li
      *ngFor="let item of clientCard"
      class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
    >
      <div class="text-500 w-2 md:w-5 font-medium">
        {{ item.label }}
      </div>
      <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
        {{ item.value }}
      </div>
    </li>
  </ul>
</div>

<pg-client-create
  *ngIf="openClientCreate"
  (close)="openClientCreate = false"
></pg-client-create>

<pg-client-select
  *ngIf="select.client.openDialog"
  (selectedRowsEvent)="onSelectedClient($event)"
>
</pg-client-select>
